import React from 'react';
import { systemText } from '../../helpers/string';

import './benchmark.css';

const Benchmark = props => {
	const { percent, title, source, style } = props;

	let bar = 'disabled';
	let colour = '';
	if (percent < 34 && percent >= 0) {
		colour = 'red';
		bar = 'danger';
	} else if (percent >= 67) {
		colour = 'green';
		bar = 'success';
	} else if (percent >= 34) {
		colour = 'orange';
		bar = 'warning';
	}

	const testId = source ? `${source}-benchmark-${bar}` : `benchmark-${bar}`;

	return (
		<div className="benchmark" data-testid={testId}>
			{style !== 'simple' && (
				<div className="flex text-sm mb5">
					<div className="flex-grow">{title ? title : systemText('General/Controls/Benchmark/Label')}</div>
					<div className={`ml5 badge bg-${colour}`} data-testid="benchmark-badge">
						{percent >= 0 ? `${percent}%` : systemText('General/Controls/Benchmark/NA')}
					</div>
				</div>
			)}
			<div className="progress progress-xs">
				<div className={`progress-bar progress-bar-${bar}`} style={{ width: percent >= 0 ? `${percent}%` : '0%' }} />
			</div>
		</div>
	);
};

export default Benchmark;
